import React, { Fragment } from 'react';
import {
  AppUserAdminActionCreators,
  ApplicationState,
  AppActionCreators,
  AppState
} from '../../../store';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import {
  Box,
  TextField,
  Card,
  CardContent,
  Tabs,
  Tab,
  Switch,
  FormControlLabel,
  Chip
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import { withSnackbar, ProviderContext } from 'notistack';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import { ScaleLoader } from 'react-spinners';
import MaterialTable, { Column, Icons } from 'material-table';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { Label } from 'reactstrap';
import moment from 'moment';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { forwardRef } from 'react';
import { IWorkflowService } from '../../../services/Interfaces/IWorkflowService';
import { WorkflowInterface } from '../../../interfaces/Workflow';
import { ALTERNATIVE_SPARE_USE_OPTIONS, ReferentialCode } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import { IReferential } from '../../../interfaces/IReferential';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddCircleTwoToneIcon {...props} ref={ref} color="secondary" />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} color="error" />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} color="primary" />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
} as Icons;

interface IWorkflowInterfacesState {
  interfaces: WorkflowInterface[];
  functionalGroups: IReferential[];
  isLoading: boolean;
  workflowId: number;
}
type WorkflowInterfacesProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class WorkflowInterfaces extends React.PureComponent<
  WorkflowInterfacesProps,
  IWorkflowInterfacesState
> {
  private translatorService!: ITranslatorService;
  private workflowService!: IWorkflowService;
  private appReferentialService!: IReferentialService;
  static contextType = ApplicationContext;
  state = {
    interfaces: [],
    functionalGroups: [],
    isLoading: true,
    workflowId: 0
  } as IWorkflowInterfacesState;
  componentDidMount = () => {
    const hoId = Number.parseInt(this.props.match.params.id);
    const workflowId = Number.parseInt(this.props.match.params.workflowId);
    this.setState(
      {
        isLoading: true
      },
      () => {
        this.loadWorkflowInterfaces();
      }
    );
  };
  loadWorkflowInterfaces = async () => {
    const hoId = Number.parseInt(this.props.match.params.id);
    const workflowId = Number.parseInt(this.props.match.params.workflowId);
    if (Number.isNaN(hoId) || Number.isNaN(workflowId)) {
      return;
    }
    try {
      const functionalGroupRef = Referentials.referential.find(
        (item) => item.code === ReferentialCode.FunctionalGroup
      );

      const [data, functionalGroups] = await Promise.all([
        this.workflowService.GetWorkflowInterfaces(workflowId),
        this.appReferentialService.Get(functionalGroupRef!.baseUrl)
      ]);

      data.forEach((item) => {
        item.functionalGroup =
          functionalGroups.find((group) => group.id === item.functionalGroupId) ?? null;
      });

      this.setState({
        interfaces: data,
        functionalGroups: functionalGroups,
        isLoading: false,
        workflowId: workflowId
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  getColumns = () => {
    return [
      {
        field: 'clientAccess',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_CLIENT_ACCESS_HEADER',
          'Acces client'
        ),
        render: (rowData: any) => {
          return (
            <FormControlLabel
              control={
                <Switch
                  checked={rowData.clientAccess}
                  value={rowData.isActive}
                  color="primary"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  disabled
                />
              }
              label={''}
            />
          );
        },
        editComponent: (props) => (
          <FormControlLabel
            control={
              <Switch
                checked={props.value}
                value={props.value}
                onChange={(e) => props.onChange(e.target.checked)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            }
            label={''}
          />
        )
      } as Column<any>,
      {
        field: 'supportsOAuth2',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_CLIENT_OAUTH2_HEADER',
          'OAuth2'
        ),
        render: (rowData: any) => {
          return (
            <FormControlLabel
              control={
                <Switch
                  checked={rowData.supportsOAuth2}
                  value={rowData.supportsOAuth2}
                  color="primary"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  disabled
                />
              }
              label={''}
            />
          );
        },
        editComponent: (props) => (
          <FormControlLabel
            control={
              <Switch
                checked={props.value}
                value={props.value}
                onChange={(e) => props.onChange(e.target.checked)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            }
            label={''}
          />
        )
      } as Column<any>,
      {
        field: 'aftSupplier',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_AFT_SUPPLIER_HEADER',
          'Uleiul Grupului'
        ),
        render: (rowData: any) => {
          return (
            <FormControlLabel
              control={
                <Switch
                  checked={rowData.aftSupplier}
                  value={rowData.aftSupplier}
                  color="primary"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  disabled
                />
              }
              label={''}
            />
          );
        },
        editComponent: (props) => (
          <FormControlLabel
            control={
              <Switch
                checked={props.value}
                value={props.value}
                onChange={(e) => props.onChange(e.target.checked)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            }
            label={''}
          />
        )
      } as Column<any>,
      {
        field: 'disabledVehicleIdentification',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_DISABLED_VEHICLE_IDENTIFICATION_HEADER',
          'Buton VQ disabled'
        ),
        render: (rowData: any) => {
          return (
            <FormControlLabel
              control={
                <Switch
                  checked={rowData.disabledVehicleIdentification}
                  value={rowData.disabledVehicleIdentification}
                  color="primary"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  disabled
                />
              }
              label={''}
            />
          );
        },
        editComponent: (props) => (
          <FormControlLabel
            control={
              <Switch
                checked={props.value}
                value={props.value}
                onChange={(e) => props.onChange(e.target.checked)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            }
            label={''}
          />
        )
      } as Column<any>,
      {
        field: 'functionalGroupId',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_FUNCTIONAL_GROUP_HEADER',
          'Functional Group GT'
        ),
        searchable: false,
        render: (rowData: WorkflowInterface) => {
          return rowData.functionalGroup ? rowData.functionalGroup.displayName : '';
        },
        editComponent: (props: any) => {
          const value =
            this.state.functionalGroups.find((group) => group.id === props.value) ?? null;
          return (
            <Autocomplete
              id="functionalGroupId"
              className="m-2"
              options={this.state.functionalGroups}
              value={value}
              onChange={(_e, newValue) => {
                props.rowData.functionalGroup = newValue ?? null;
                props.onChange(newValue?.id ?? null);
              }}
              getOptionLabel={(option) => option.displayName}
              renderInput={(params) => (
                <TextField {...params} name="functionalGroupId" fullWidth />
              )}
            />
          );
        }
      } as Column<any>,
      {
        field: 'alternativeSpareUse',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_ALTERNATIVE_SPARE_USE_HEADER',
          'Use alternative spare'
        ),
        searchable: false,
        render: (rowData: WorkflowInterface) => {
          const option = ALTERNATIVE_SPARE_USE_OPTIONS.find(
            (o) => o.value === rowData.alternativeSpareUse
          );
          return option ? option.label : 'Only';
        },
        editComponent: (props: any) => {
          const value =
            ALTERNATIVE_SPARE_USE_OPTIONS.find((o) => o.value === props.value) ??
            ALTERNATIVE_SPARE_USE_OPTIONS[2];
          return (
            <Autocomplete
              id="alternativeSpareUse"
              className="m-2"
              options={[...ALTERNATIVE_SPARE_USE_OPTIONS]}
              value={value}
              onChange={(_e, newValue) => props.onChange(newValue?.value ?? 3)}
              getOptionLabel={(option) => option.label || ''}
              renderInput={(params) => (
                <TextField {...params} name="alternativeSpareUse" fullWidth />
              )}
            />
          );
        }
      } as Column<any>,
      // {
      //   field: 'partsSuggestion',
      //   title: this.translatorService.Tranlate(
      //     'ORGANIZATION_INTERFACE_PARTS_SUGGESTION_HEADER',
      //     'Sugestie Piese'
      //   ),
      //   render: (rowData: any) => {
      //     return (
      //       <FormControlLabel
      //         control={
      //           <Switch
      //             checked={rowData.partsSuggestion}
      //             value={rowData.partsSuggestion}
      //             color="primary"
      //             inputProps={{ 'aria-label': 'primary checkbox' }}
      //             disabled
      //           />
      //         }
      //         label={''}
      //       />
      //     );
      //   },
      //   editComponent: (props) => (
      //     <FormControlLabel
      //       control={
      //         <Switch
      //           checked={props.value}
      //           value={props.value}
      //           onChange={(e) => props.onChange(e.target.checked)}
      //           color="primary"
      //           inputProps={{ 'aria-label': 'primary checkbox' }}
      //         />
      //       }
      //       label={''}
      //     />
      //   )
      // } as Column<any>,
      // {
      //   field: 'viewPartsIncludedByHierarchy',
      //   title: this.translatorService.Tranlate(
      //     'ORGANIZATION_INTERFACE_VIEW_PARTS_INCLUDED_BY_HIERARCHY_HEADER',
      //     'Vizualizare Piese Incluse în Ierarhie'
      //   ),
      //   render: (rowData: any) => {
      //     return (
      //       <FormControlLabel
      //         control={
      //           <Switch
      //             checked={rowData.viewPartsIncludedByHierarchy}
      //             value={rowData.viewPartsIncludedByHierarchy}
      //             color="primary"
      //             inputProps={{ 'aria-label': 'primary checkbox' }}
      //             disabled
      //           />
      //         }
      //         label={''}
      //       />
      //     );
      //   },
      //   editComponent: (props) => (
      //     <FormControlLabel
      //       control={
      //         <Switch
      //           checked={props.value}
      //           value={props.value}
      //           onChange={(e) => props.onChange(e.target.checked)}
      //           color="primary"
      //           inputProps={{ 'aria-label': 'primary checkbox' }}
      //         />
      //       }
      //       label={''}
      //     />
      //   )
      // } as Column<any>,
      {
        field: 'smallPartPercentage',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_SMALL_PART_PERCENTAGE_HEADER',
          'Piese mici %'
        ),
        searchable: true
      } as Column<any>,
      {
        field: 'code',
        cellStyle: { minWidth: 150 },
        headerStyle: { minWidth: 150 },
        title: this.translatorService.Tranlate('ORGANIZATION_INTERFACE_CODE_HEADER', 'Cod'),
        searchable: true
      } as Column<any>,
      {
        field: 'url',
        cellStyle: { minWidth: 280 },
        headerStyle: { minWidth: 280 },
        title: this.translatorService.Tranlate('ORGANIZATION_INTERFACE_URL_HEADER', 'URL'),
        searchable: true
      } as Column<any>,
      {
        field: 'port',
        cellStyle: { minWidth: 120 },
        headerStyle: { minWidth: 120 },
        title: this.translatorService.Tranlate('ORGANIZATION_INTERFACE_PORT_HEADER', 'Port'),
        searchable: true
      } as Column<any>,
      {
        field: 'refreshTokenValidUntil',
        title: this.translatorService.Tranlate('ORGANIZATION_INTERFACE_STATUS_HEADER', 'Status'),
        editable: 'never',
        render: (rowData: WorkflowInterface) => {
          if (!rowData.supportsOAuth2) {
            return (
              <Chip
                label={this.translatorService.Tranlate(
                  'ORGANIZATION_INTERFACE_STATUS_ACTIVE',
                  'Activa'
                )}
                style={{ backgroundColor: '#2e7d32', color: 'white' }}
              />
            );
          }

          if (!rowData.refreshTokenValidUntil) {
            return (
              <Chip
                label={this.translatorService.Tranlate(
                  'ORGANIZATION_INTERFACE_STATUS_INACTIVE',
                  'Inactiva'
                )}
                style={{ backgroundColor: '#d32f2f', color: 'white' }}
              />
            );
          }

          if (
            rowData.refreshTokenValidUntil &&
            moment.utc(rowData.refreshTokenValidUntil).isAfter(moment.utc())
          ) {
            return (
              <Chip
                label={this.translatorService.Tranlate(
                  'ORGANIZATION_INTERFACE_STATUS_ACTIVE',
                  'Activa'
                )}
                style={{ backgroundColor: '#2e7d32', color: 'white' }}
              />
            );
          }

          return (
            <Chip
              label={this.translatorService.Tranlate(
                'ORGANIZATION_INTERFACE_STATUS_INACTIVE',
                'Inactiva'
              )}
              style={{ backgroundColor: '#d32f2f', color: 'white' }}
            />
          );
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        editComponent: (props: any) => {
          if (!props.rowData.supportsOAuth2) {
            return <></>;
          }
          return (
            <TextField
              value={props.value}
              fullWidth={true}
              type="text"
              onChange={(e) => props.onChange(e.target.value)}
            />
          );
        }
      } as Column<WorkflowInterface>,
      {
        field: 'userName',
        cellStyle: { minWidth: 180 },
        headerStyle: { minWidth: 180 },
        title: this.translatorService.Tranlate('ORGANIZATION_INTERFACE_UER_HEADER', 'Utilizator'),
        searchable: true,
        render: (props: WorkflowInterface) => {
          if (props.clientAccess) {
            return '-';
          }

          return props.userName;
        },
        editComponent: (props: any) => {
          if (props.rowData.clientAccess) {
            return <></>;
          }

          return (
            <TextField
              value={props.value}
              fullWidth={true}
              type="text"
              onChange={(e) => props.onChange(e.target.value)}
            />
          );
        }
      },
      {
        field: 'password',
        cellStyle: { minWidth: 160 },
        headerStyle: { minWidth: 160 },
        title: this.translatorService.Tranlate('ORGANIZATION_INTERFACE_PASSWORD_HEADER', 'Parola'),
        render: (props: WorkflowInterface) => {
          if (props.clientAccess) {
            return '-';
          }
          return '***';
        },
        editComponent: (props: any) => {
          if (props.rowData.clientAccess) {
            return <></>;
          }

          return (
            <TextField
              value={props.value}
              fullWidth={true}
              type="password"
              onChange={(e) => props.onChange(e.target.value)}
            />
          );
        }
      } as Column<any>,
      {
        field: 'customerId',
        cellStyle: { minWidth: 180 },
        headerStyle: { minWidth: 180 },
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_CUSTOMER_ID_HEADER',
          'Client Id'
        ),
        searchable: true,
        render: (props: WorkflowInterface) => {
          if (props.clientAccess) {
            return '-';
          }

          if (props.supportsOAuth2) {
            return '***';
          }

          return props.customerId;
        },
        editComponent: (props: any) => {
          if (props.rowData.clientAccess) {
            return <></>;
          }

          return (
            <TextField
              value={props.value}
              fullWidth={true}
              type="text"
              onChange={(e) => props.onChange(e.target.value)}
            />
          );
        }
      },
      {
        field: 'secondUser',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_SECOND_USER_HEADER',
          'Utilizator 2'
        ),
        searchable: true,
        render: (props: WorkflowInterface) => {
          if (props.clientAccess || props.supportsOAuth2) {
            return '-';
          }

          return props.secondUser;
        },
        editComponent: (props: any) => {
          if (props.rowData.clientAccess || props.supportsOAuth2) {
            return <></>;
          }

          return (
            <TextField
              value={props.value}
              fullWidth={true}
              type="text"
              onChange={(e) => props.onChange(e.target.value)}
            />
          );
        }
      },
      {
        field: 'additionSeries',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_INTERFACE_ADDITION_SERIES_HEADER',
          'Serie Comision GTM'
        ),
        searchable: true,
        render: (props: WorkflowInterface) => {
          if (props.clientAccess || props.supportsOAuth2) {
            return '-';
          }
          return props.additionSeries;
        },
        editComponent: (props: any) => {
          if (props.rowData.clientAccess || props.supportsOAuth2) {
            return <></>;
          }
          return (
            <TextField
              value={props.value}
              fullWidth={true}
              type="text"
              onChange={(e) => props.onChange(e.target.value)}
            />
          );
        }
      }
    ];
  };
  public getLocalization = () => {
    return {
      header: { actions: '' },
      toolbar: {
        searchPlaceholder: this.translatorService.Tranlate('SEARCH', 'Cauta'),
        searchTooltip: this.translatorService.Tranlate('SEARCH', 'Cauta')
      },
      body: {
        editTooltip: this.translatorService.Tranlate('EDIT', 'Editeaza'),
        deleteTooltip: this.translatorService.Tranlate('DELETE', 'Sterge'),
        addTooltip: this.translatorService.Tranlate('Add', 'Adauga'),
        emptyDataSourceMessage: this.translatorService.Tranlate(
          'NO_RECORDS_TO_DISPLAY',
          'Nu exista date de afisat'
        ),
        editRow: {
          cancelTooltip: this.translatorService.Tranlate('CANCEL', 'Anuleaza'),
          saveTooltip: this.translatorService.Tranlate('SAVE', 'Salveaza'),
          deleteText: this.translatorService.Tranlate(
            'DELETE_TEXT',
            'Sigur doriti sa stergeti aceasta inregistrare?'
          )
        }
      },
      pagination: {
        labelRowsSelect: this.translatorService.Tranlate('ROWS', 'inregistrari'),
        firstTooltip: this.translatorService.Tranlate('FIRST_PAGE', 'Prima pagina'),
        previousTooltip: this.translatorService.Tranlate('PREVIOUS_PAGE', 'Pagina precedenta'),
        nextTooltip: this.translatorService.Tranlate('NEXT_PAGE', 'Pagina urmatoare'),
        lastTooltip: this.translatorService.Tranlate('LAST_PAGE', 'Ultima pagina'),
        labelDisplayedRows:
          '{from}-{to} ' + this.translatorService.Tranlate('OF', 'din') + ' {count}'
      }
    };
  };
  onRowUpdate = (newData: WorkflowInterface, oldData?: WorkflowInterface): Promise<void> =>
    new Promise(async (resolve, reject) => {
      if (oldData) {
        try {
          await this.workflowService.UpdateWorkflowInterface(newData);
          await this.loadWorkflowInterfaces();
          this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
            variant: 'success'
          });
          resolve();
        } catch (error) {
          this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
            variant: 'error'
          });
          reject();
        }
      }
    });
  onRowDelete = (oldData: WorkflowInterface): Promise<void> =>
    new Promise(async (resolve, reject) => {
      if (oldData) {
        try {
          await this.workflowService.RemoveWorkflowInterface(oldData.id);
          await this.loadWorkflowInterfaces();
          this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
            variant: 'success'
          });
          resolve();
        } catch (error) {
          this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
            variant: 'error'
          });
          reject();
        }
      }
    });
  onRowAdd = (newData: WorkflowInterface): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        newData.workflowId = this.state.workflowId;
        await this.workflowService.AddWorkflowInterface(newData);
        await this.loadWorkflowInterfaces();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
        resolve();
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
        reject();
      }
    });
  public renderTable = () => {
    return (
      <MaterialTable
        icons={tableIcons}
        title=" "
        columns={this.getColumns()}
        data={this.state.interfaces}
        options={{
          actionsColumnIndex: -1,
          addRowPosition: 'first'
        }}
        localization={this.getLocalization()}
        editable={{
          onRowAdd: (newData: any) => this.onRowAdd(newData),
          onRowUpdate: (newData: any, oldData?: any) => this.onRowUpdate(newData, oldData),
          onRowDelete: (oldData: any) => this.onRowDelete(oldData)
        }}
      />
    );
  };
  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    this.workflowService = (this.context as AppContext).workflowService;
    return (
      <Fragment>
        <Box>
          <Card>
            <CardContent>
              <Tabs
                value={0}
                indicatorColor="primary"
                textColor="primary"
                variant="standard"
                color="primary"
                aria-label="disabled tabs example"
              >
                <Tab
                  className="text-capitalize"
                  label={this.translatorService.Tranlate('WORKFLOW_TAB_INTERFACES', 'Interfete')}
                />
              </Tabs>
            </CardContent>
          </Card>
        </Box>
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? this.renderTable() : null}
        </Box>
      </Fragment>
    );
  }
}
const mergeProps = (stateProps: any, dispatchProps: any, ownProps: WorkflowInterfacesProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});
export default connect(
  (state: ApplicationState) => ({ appState: state.app }),
  { ...AppUserAdminActionCreators, ...AppActionCreators },
  mergeProps
)(withSnackbar(WorkflowInterfaces as any));
